import { Chip, ChipProps } from "@mui/material";
import React from "react";

import { IApplicationStatus } from "../../generated/types";

interface IProps {
    status: IApplicationStatus;
}

export const ApplicationStatusChip: React.FC<IProps> = ({ status }) => {
    return (
        <Chip
            {...APPLICATION_STATUS_DISPLAY_OPTS[status]}
            label={getApplicationStatusDisplayName(status)}
            size="small"
        />
    );
};

interface IStatusDisplayOpts {
    color: ChipProps["color"];
}

const APPLICATION_STATUS_DISPLAY_OPTS: Record<IApplicationStatus, IStatusDisplayOpts> = {
    [IApplicationStatus.AccountSetup]: { color: undefined },
    [IApplicationStatus.Approved]: { color: "default" },
    [IApplicationStatus.AwaitingDocuments]: { color: "error" },
    [IApplicationStatus.Canceled]: { color: "default" },
    [IApplicationStatus.Denied]: { color: "default" },
    [IApplicationStatus.New]: { color: undefined },
    [IApplicationStatus.Pending]: { color: "default" },
    [IApplicationStatus.PendingReview]: { color: "default" },
    [IApplicationStatus.SubmissionError]: { color: "default" },
};

const APPLICATION_STATUS_DISPLAY_NAME: Record<IApplicationStatus, string> = {
    [IApplicationStatus.AccountSetup]: "Approved",
    [IApplicationStatus.Approved]: "Pending",
    [IApplicationStatus.AwaitingDocuments]: "Requires Action",
    [IApplicationStatus.Canceled]: "Canceled",
    [IApplicationStatus.Denied]: "Denied",
    [IApplicationStatus.New]: "New",
    [IApplicationStatus.Pending]: "Pending",
    [IApplicationStatus.PendingReview]: "Pending",
    [IApplicationStatus.SubmissionError]: "Pending",
};

export function getApplicationStatusDisplayName(status: IApplicationStatus): string {
    return APPLICATION_STATUS_DISPLAY_NAME[status] ?? "Unknown";
}
